import { ligainicial } from "./rutainicial.js";
import { pagesipdus } from "./rutainicial";

const ligabase = ligainicial + "2026/Lic/C";
const ligasipdus = pagesipdus + "2026/Lic/C";

export const licitacionesVigentes = [
    {
        // CONVOCATORIA NUM# 034
        'numConvocatoria' : 'Convocatoria No. 034/2026.',
        'numProcedimiento' : 'EO-SIPDUS-N95-2026.',
        'vigencia' : '3 al 7 de agosto de 2026.',
        'descripcionProcedimiento' : 'Infraestructura complementaria del complejo "Hidalgo Honesto".; ubicada en la localidad de San Juan Tilcuautla, Municipio de San Agustín Tlaxiaca, Estado de Hidalgo  (Tercer procedimiento)',
        'urlAnexos' : `${ ligasipdus }34/N95/N95.rar`,
        'start' : '2026-08-03',
        'end' : '2026-08-07',
        'procedimiento' : 'Licitación Pública',
    },
    {
        // CONVOCATORIA NUM# 033
        'numConvocatoria' : 'Convocatoria No. 033/2026.',
        'numProcedimiento' : 'EO-SIPDUS-N94-2026.',
        'vigencia' : '3 al 14 de agosto de 2026.',
        'descripcionProcedimiento' : 'Mantenimiento de Cuartel del Arte.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }33/N94/N94.rar`,
        'start' : '2026-08-03',
        'end' : '2026-08-14',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N93-2026.',
        'vigencia' : '3 al 14 de agosto de 2026.',
        'descripcionProcedimiento' : 'Construcción de la Casa de la Mujer Indígena 2da Etapa en el municipio de Atlapexco; ubicada en la localidad y Municipio de Atlapexco, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }33/N93/N93.rar`,
        'start' : '2026-08-03',
        'end' : '2026-08-14',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N92-2026.',
        'vigencia' : '3 al 14 de agosto de 2026.',
        'descripcionProcedimiento' : 'Construcción de Corredor Artesanal y Gastronómico en la Región Huasteca, ubicado en la unidad deportiva Luis Donaldo Colosio Murrieta, municipio de San Felipe Orizatlán; ubicada en la localidad y Municipio de San Felipe Orizatlán, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }33/N92/N92.rar`,
        'start' : '2026-08-03',
        'end' : '2026-08-14',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N91-2026.',
        'vigencia' : '3 al 14 de agosto de 2026.',
        'descripcionProcedimiento' : 'Construcción de corredor artesanal y gastronómico ubicado en la cabecera municipal de Actopan; ubicada en la localidad y Municipio de Actopan, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }33/N91/N91.rar`,
        'start' : '2026-08-03',
        'end' : '2026-08-14',
        'procedimiento' : 'Licitación Pública',
    },
    {
        // CONVOCATORIA NUM# 032
        'numConvocatoria' : 'Convocatoria No. 032/2026.',
        'numProcedimiento' : 'EO-SIPDUS-N90-2026.',
        'vigencia' : '27 de julio al 10 de agosto de 2026.',
        'descripcionProcedimiento' : 'Reconstrucción de la C.E. San Francisco - San Joaquín (tramo el mercader - San Joaquín), en el municipio de Tecozautla.; ubicada en la localidad y Municipio de Tecozautla, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }32/N90/N90.rar`,
        'start' : '2026-07-27',
        'end' : '2026-08-10',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N89-2026.',
        'vigencia' : '27 de julio al 10 de agosto de 2026.',
        'descripcionProcedimiento' : 'Construcción de Corredor Artesanal y Gastronómico ubicado en la Región Otomí-Tepehua, ubicado en la Cabecera Municipal de Huehuetla.; ubicada en la localidad y Municipio de Huehuetla, Estado de Hidalgo (Segundo Procedimiento)',
        'urlAnexos' : `${ ligasipdus }32/N89/N89.rar`,
        'start' : '2026-07-27',
        'end' : '2026-08-10',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N88-2026.',
        'vigencia' : '27 de julio al 10 de agosto de 2026.',
        'descripcionProcedimiento' : 'Mejoramiento de Imagen Urbana en el Centro Histórico Atlapexco.; ubicada en la localidad y Municipio de Atlapexco, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }32/N88/N88.rar`,
        'start' : '2026-07-27',
        'end' : '2026-08-10',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N87-2026.',
        'vigencia' : '27 de julio al 10 de agosto de 2026.',
        'descripcionProcedimiento' : 'Construcción del nuevo taller de órtesis y prótesis en el municipio de Pachuca de Soto,Hgo.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }32/N87/N87.rar`,
        'start' : '2026-07-27',
        'end' : '2026-08-10',
        'procedimiento' : 'Licitación Pública',
    },
]